import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,{attrs:{"loading":_vm.loading,"items":[],"return-object":true,"error-messages":_vm.errors.token,"chips":"","multiple":""},on:{"input":_vm.addRfidToken},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
return [_c(VChip,_vm._b({attrs:{"close":"","small":""},on:{"click:close":function($event){return _vm.deleteRfidToken(item)}}},'VChip',attrs,false),[_vm._v(_vm._s(item.secret))])]}}]),model:{value:(_vm.rfidTokens),callback:function ($$v) {_vm.rfidTokens=$$v},expression:"rfidTokens"}})}
var staticRenderFns = []

export { render, staticRenderFns }